export const changeProductReferenceData = {
  changeMyProductSubtitle: {
    informationText:
      '<p>Welcome to Defence Health. Tell us about yourself and we&rsquo;ll help you find the health cover that meets your needs.</p>\r\n\r\n<p>The Australian Government Lifetime Health Cover loading may increase your hospital cover premium.&nbsp; The quote tool below may overstate any applicable increase.&nbsp; The actual premium will be calculated when completing the join process. For more details visit&nbsp;<u><a href="https://www.defencehealth.com.au/Health-Insurance/Explore-Health-Cover/Lifetime-Health-Cover" target="_blank">Lifetime Health Cover</a></u>.</p>\r\n',
  },
  startDate: {
    label: 'Start date of cover change',
    helpText: '',
  },
  state: {
    label: 'I live in',
    helpText: '<p>Premiums may vary according to health costs in each state or territory</p>\r\n',
    options: [
      {
        display: 'ACT',
        returnValue: 'ACT',
      },
      {
        display: 'NSW',
        returnValue: 'NSW',
      },
      {
        display: 'NT',
        returnValue: 'NT',
      },
      {
        display: 'QLD',
        returnValue: 'QLD',
      },
      {
        display: 'SA',
        returnValue: 'SA',
      },
      {
        display: 'TAS',
        returnValue: 'TAS',
      },
      {
        display: 'VIC',
        returnValue: 'VIC',
      },
      {
        display: 'WA',
        returnValue: 'WA',
      },
    ],
  },
  eligibility: {
    label: 'I can join Defence Health because',
    helpText:
      '<p>Related means the parent, child, sibling, grandchild or ex-spouse/partner​.<br />\r\n<br />\r\n​Work connection means a Defence related government department or contract​.</p>\r\n',
    options: [
      {
        display: 'I/My partner is currently serving',
        returnValue: 'ADF',
      },
      {
        display: 'I/My partner has served',
        returnValue: 'ExServing',
      },
      {
        display: 'I/My partner is related to someone who is eligible to join',
        returnValue: 'Supporting',
      },
      {
        display: 'I/My partner work for a Defence company or Dept of Defence',
        returnValue: 'WorkConnection',
      },
    ],
  },
  dvaCard: {
    label: 'I/My partner hold a Veterans Card',
    helpText: '<p>Holding a DVA Veteran Card may reduce your premiums</p>\r\n',
  },
  coverComposition: {
    label: 'I want my policy to cover',
    helpText: "<p>While single, kids can be covered until they turn 31. Higher premium and product requirements apply if they're not studying.&nbsp;</p>\r\n",
    additionalHelpText: '',
    options: [
      {
        isShown: true,
        display: 'Single person',
        returnValue: 'single',
      },
      {
        isShown: true,
        display: 'Couple',
        returnValue: 'couple',
      },
      {
        isShown: true,
        display: 'Family',
        returnValue: 'family',
      },
      {
        isShown: true,
        display: 'Single parent family',
        returnValue: 'singleParent',
      },
      {
        isShown: true,
        display: 'Child / Children only',
        returnValue: 'childrenOnly',
      },
      {
        isShown: false,
        display: 'Family plus',
        returnValue: 'familyPlus',
      },
      {
        isShown: false,
        display: 'Single parent plus',
        returnValue: 'singleParentPlus',
      },
    ],
  },
  postalAddressHelpText: {
    informationText: 'Placeholder content',
  },
  partnerAge: {
    label: 'My partner’s birthdate is',
    helpText: '',
  },
  numberOfChildren: {
    label: 'The number of children I need cover for is​',
    helpText: '<p>Include the total number of children you require cover for.</p>\r\n',
  },
  familyPlus: {
    label: 'At least one dependant is aged 21–30 inclusive and not studying full-time',
    helpText: '<p>Single, non-student dependants can remain covered to age 30. Higher premium and combined cover applies.</p>\r\n',
  },
  incomeTier: {
    label: 'My household income for determining the rebate is',
    helpText: '<p>We ask your income to calculate rebates that you may be entitled to. Find out more at the <a href="https://www.ato.gov.au/" target="_blank">ATO</a>.</p>\r\n',
    options: [
      {
        display: '$93,000 or less',
        returnValue: 'BASE_TIER',
      },
      {
        display: '$93,001 - $108,000',
        returnValue: 'TIER_1',
      },
      {
        display: '$108,001 - $144,000',
        returnValue: 'TIER_2',
      },
      {
        display: '$144,001 or more',
        returnValue: 'TIER_3',
      },
      {
        display: "Don't apply a rebate",
        returnValue: 'none',
      },
    ],
  },
  familyIncomeTier: {
    label: 'My household income for determining the rebate is',
    helpText: '<p>We ask your income to calculate rebates that you may be entitled to. Find out more at the <a href="https://www.ato.gov.au/" target="_blank">ATO</a>.</p>\r\n',
    options: [
      {
        display: '$186,000 or less',
        returnValue: 'BASE_TIER',
      },
      {
        display: '$186,001 - $216,000',
        returnValue: 'TIER_1',
      },
      {
        display: '$216,001 - $288,000',
        returnValue: 'TIER_2',
      },
      {
        display: '$288,001 or more',
        returnValue: 'TIER_3',
      },
      {
        display: "Don't apply a rebate",
        returnValue: 'none',
      },
    ],
  },
  myCircumstances: {
    label: 'In my household',
    helpText: '',
    options: [
      {
        display: "It's just me",
        returnValue: 'single',
      },
      {
        display: 'I have kids and/or a partner',
        returnValue: 'other',
      },
    ],
  },
  coverType: {
    label: 'The cover I am after is',
    helpText: '<p>Your current cover is a&nbsp;closed product. If you change this cover you cannot move back.&nbsp;</p>\r\n',
    options: [
      {
        display: 'Hospital & Extras',
        returnValue: 'both',
      },
      {
        display: 'Hospital only',
        returnValue: 'hospital',
      },
      {
        display: 'Extras only',
        returnValue: 'extras',
      },
    ],
  },
  reviewCover: {
    label: 'I would like to review',
    helpText:
      '<p>The current product you are on is no longer available. If you choose to continue with this product change you will be unable to move back on to your current product.</p>\r\n',
    options: [
      {
        display: 'Hospital cover',
        returnValue: 'hospital',
      },
      {
        display: 'Extras cover',
        returnValue: 'extras',
      },
      {
        display: 'Both',
        returnValue: 'both',
      },
    ],
  },
  coverReason: {
    label: 'The type of cover I am looking for is',
    helpText: '',
    options: [
      {
        display: 'Good all round cover',
        returnValue: 'allRound',
      },
      {
        display: 'Planning a family',
        returnValue: 'planningFamily',
      },
      {
        display: 'Total peace of mind',
        returnValue: 'peaceOfMind',
      },
      {
        display: 'Just the basics',
        returnValue: 'basics',
      },
      {
        display: 'Specific treatment',
        returnValue: 'specific',
      },
    ],
  },
  hospitalNeeds: {
    label: 'The most important clinical categories I’d like included in my cover are (select up to 5):​',
    helpText: '',
    options: [
      {
        display: 'Assisted reproductive services',
        returnValue: 'Assisted reproductive services',
      },
      {
        display: 'Back, neck and spine',
        returnValue: 'Back, neck and spine',
      },
      {
        display: 'Blood',
        returnValue: 'Blood',
      },
      {
        display: 'Bone, joint and muscle',
        returnValue: 'Bone, joint and muscle',
      },
      {
        display: 'Brain and nervous system',
        returnValue: 'Brain and nervous system',
      },
      {
        display: 'Breast surgery (medically necessary)',
        returnValue: 'Breast surgery (medically necessary)',
      },
      {
        display: 'Cataracts',
        returnValue: 'Cataracts',
      },
      {
        display: 'Chemotherapy, radiotherapy and immunotherapy for cancer',
        returnValue: 'Chemotherapy, radiotherapy and immunotherapy for cancer',
      },
      {
        display: 'Dental surgery',
        returnValue: 'Dental surgery',
      },
      {
        display: 'Diabetes management (excluding insulin pumps)',
        returnValue: 'Diabetes management (excluding insulin pumps)',
      },
      {
        display: 'Dialysis for chronic kidney failure',
        returnValue: 'Dialysis for chronic kidney failure',
      },
      {
        display: 'Digestive system',
        returnValue: 'Digestive system',
      },
      {
        display: 'Ear, nose and throat',
        returnValue: 'Ear, nose and throat',
      },
      {
        display: 'Eye (not cataracts)',
        returnValue: 'Eye (not cataracts)',
      },
      {
        display: 'Gastrointestinal endoscopy',
        returnValue: 'Gastrointestinal endoscopy',
      },
      {
        display: 'Gynaecology',
        returnValue: 'Gynaecology',
      },
      {
        display: 'Heart and vascular system',
        returnValue: 'Heart and vascular system',
      },
      {
        display: 'Hernia and appendix',
        returnValue: 'Hernia and appendix',
      },
      {
        display: 'Hospital psychiatric services',
        returnValue: 'Hospital Psychiatric services',
      },
      {
        display: 'Implantation of hearing devices',
        returnValue: 'Implantation of hearing devices',
      },
      {
        display: 'Insulin pumps',
        returnValue: 'Insulin pumps',
      },
      {
        display: 'Joint reconstructions',
        returnValue: 'Joint reconstructions',
      },
      {
        display: 'Kidney and bladder',
        returnValue: 'Kidney and bladder',
      },
      {
        display: 'Lung and chest',
        returnValue: 'Lung and chest',
      },
      {
        display: 'Male reproductive system',
        returnValue: 'Male reproductive system',
      },
      {
        display: 'Miscarriage and termination of pregnancy',
        returnValue: 'Miscarriage and termination of pregnancy',
      },
      {
        display: 'Pain management',
        returnValue: 'Pain management',
      },
      {
        display: 'Pain management with device',
        returnValue: 'Pain management with device',
      },
      {
        display: 'Palliative care',
        returnValue: 'Palliative care',
      },
      {
        display: 'Plastic and reconstructive surgery (medically necessary)',
        returnValue: 'Plastic and reconstructive surgery (medically necessary)',
      },
      {
        display: 'Podiatric surgery (provided by a registered podiatric surgeon)',
        returnValue: 'Podiatric surgery (provided by a registered podiatric surgeon)',
      },
      {
        display: 'Pregnancy and birth',
        returnValue: 'Pregnancy and Birth',
      },
      {
        display: 'Rehabilitation',
        returnValue: 'Rehabilitation',
      },
      {
        display: 'Skin',
        returnValue: 'Skin',
      },
      {
        display: 'Sleep studies',
        returnValue: 'Sleep studies',
      },
      {
        display: 'Tonsils, adenoids and grommets',
        returnValue: 'Tonsils, adenoids and grommets',
      },
      {
        display: 'Weight loss surgery',
        returnValue: 'Weight loss surgery',
      },
      {
        display: 'Joint replacements',
        returnValue: 'Joint replacements',
      },
    ],
  },
  extrasNeeds: {
    label: 'The most important extras services I’d like included in my cover are (select up to 5):',
    helpText: '',
    options: [
      {
        display: 'Antenatal and postnatal services',
        returnValue: 'Antenatal and postnatal services',
      },
      {
        display: 'Audiology',
        returnValue: 'Audiology',
      },
      {
        display: 'Chiropractic/Osteopathic',
        returnValue: 'Chiropractic/Osteopathic',
      },
      {
        display: 'Dietitian',
        returnValue: 'Dietitian',
      },
      {
        display: 'Exercise physiology',
        returnValue: 'Exercise physiology',
      },
      {
        display: 'Eye therapy',
        returnValue: 'Eye therapy',
      },
      {
        display: 'General and preventive dental',
        returnValue: 'General and preventive dental',
      },
      {
        display: 'Health and wellbeing',
        returnValue: 'Health and wellbeing',
      },
      {
        display: 'Laser refractive eye surgery',
        returnValue: 'Laser refractive eye surgery',
      },
      {
        display: 'Major Dental',
        returnValue: 'Major Dental',
      },
      {
        display: 'Medically prescribed Devices and Appliances',
        returnValue: 'Medically prescribed Devices and Appliances',
      },
      {
        display: 'Occupational Therapy',
        returnValue: 'Occupational Therapy',
      },
      {
        display: 'Optical',
        returnValue: 'Optical',
      },
      {
        display: 'Pharmacy and vaccinations',
        returnValue: 'Pharmacy and vaccinations',
      },
      {
        display: 'Podiatry/Chiropody',
        returnValue: 'Podiatry/Chiropody',
      },
      {
        display: 'Psychology',
        returnValue: 'Psychology',
      },
      {
        display: 'School Accidents',
        returnValue: 'School Accidents',
      },
      {
        display: 'Speech Therapy',
        returnValue: 'Speech Therapy',
      },
      {
        display: 'Travel vaccinations',
        returnValue: 'Travel vaccinations',
      },
      {
        display: 'Ambulance treatment',
        returnValue: 'Ambulance treatment',
      },
      {
        display: 'Physiotherapy',
        returnValue: 'Physiotherapy',
      },
      {
        display: 'Orthodontics',
        returnValue: 'Orthodontics',
      },
      {
        display: 'Surgical tooth removal',
        returnValue: 'Surgical tooth removal',
      },
    ],
  },
  pregnancy: {
    label: 'Do not include pregnancy',
    helpText: '',
  },
  backButtonLabel: {
    informationText: 'Back',
  },
  nextButtonLabel: {
    informationText: 'Next',
  },
  recommendationsButtonLabel: {
    informationText: 'See my recommendations',
  },
  recommendationsSubheading: {
    informationText: 'My recommendations',
  },
  recommendationsCurrentCoverSubheading: {
    informationText: 'My cover',
  },
  recommendationsInformationText: {
    informationText: '<p>The premium quoted, including any discounts and loadings, is based on the information you have provided as at today&rsquo;s date.</p>\r\n',
  },
  recommendationsHospitalExcessLabel: {
    informationText: 'Hospital excess',
  },
  recommendationsSelectProductButtonLabel: {
    informationText: 'Select this cover',
  },
  recommendationsKeepProductButtonLabel: {
    informationText: 'Keep my cover',
  },
  recommendationsHospitalAccordionLabel: {
    informationText: 'Hospital features',
  },
  recommendationsExtrasAccordionLabel: {
    informationText: 'Extras features',
  },
  recommendationsFooterText: {
    informationText:
      '<p>Find out more about how <a href="https://www.defencehealth.com.au/Health-Insurance/Explore-Health-Cover/things-you-need-to-know-about-health-insurance" target="_blank">rebate tiers are calculated</a>&nbsp;plus details on government incentives and surcharges.</p>\r\n\r\n<p><a href="https://www.defencehealth.com.au/Health-Insurance/Choosing-Defence-Health/Why-Choose-Us" target="_blank">Learn more</a> about the discounts we offer to our Defence community.</p>\r\n\r\n<p>Read our <a href="https://www.defencehealth.com.au/other/legal" target="_blank">Privacy&nbsp;Policy</a> to&nbsp;find out how&nbsp;we manage&nbsp;personal&nbsp;information.&nbsp; It&nbsp;also&nbsp;explains how&nbsp;personal&nbsp;information&nbsp;may be&nbsp;accessed and&nbsp;corrected and&nbsp;how to&nbsp;make a complaint.</p>\r\n',
  },
  recommendationsPromotionalTags: ['Best for you!', '', ''],
  selectedProductHeading: {
    informationText: 'Cover selection',
  },
  selectedProductInformationText: {
    informationText: '<p>Please review the changes before proceeding.</p>\r\n\r\n<p>Any changes to the premium, or the date paid to will be adjusted following the change.</p>\r\n',
  },
  selectedProductSubheading: {
    informationText: "Here's what you told us",
  },
  selectedProductChangeDetailsLinkLabel: {
    informationText: 'Change my details',
  },
  selectedProductGuideInformationText: {
    informationText:
      'The product guide and information below provide details of what is and is not covered, including any waiting periods, benefit limits and pre-existing conditions, exclusions, restrictions and excesses.',
  },
  selectedProductClosedProductInformationText: {
    informationText: '<p>Once this change is confirmed, you will not be able to return to any previously held closed products.</p>\r\n',
  },
  selectedProductMyRecommendationsLinkLabel: {
    informationText: 'Back to my recommendations',
  },
  selectedProductConfirmButtonLabel: {
    informationText: 'Confirm',
  },
  keepMyCoverHeading: {
    informationText: 'No changes have been made to the cover',
  },
  keepMyCoverSubtitle: {
    informationText: '<p>There is no change to the premium, members covered on the membership or the level of cover.</p>\r\n',
  },
  keepMyCoverSubheading: {
    informationText: 'Product information',
  },
  keepMyCoverSupportText: {
    informationText: '<p>Current cover is retained. No change to membership has been recorded.</p>\r\n',
  },
  additionalInformationPolicyChangesSupportText: {
    informationText: '<p>You have selected to change who is covered on the membership. As a result, this member will be removed automatically.</p>\r\n',
  },
  additionalInformationPolicyHolderHeading: {
    informationText: 'Member detail',
  },
  additionalInformationUpdateDetails: {
    informationText:
      'You can only edit the information needed specifically for this requested change. <br><br> If you&rsquo;d like to update your member details, please call us on <a href="tel:1800 335 425" target="_blank">1800 335 425</a>',
  },
  additionalInformationPartnerHeading: {
    informationText: 'Partner Detail',
  },
  additionalInformationKeepPartner: {
    label: 'I would like to keep this adult on the policy as a partner',
    helpText: 'Members were confirmed as part of your quote.<br> <a id="myCover">Change your details</a>',
  },
  additionalInformationPartnerSubheader: {
    informationText: 'Health insurance history',
  },
  additionalInformationChildHeading: {
    informationText: 'Dependent',
  },
  additionalInformationKeepChild: {
    label: 'I would like to keep this child on the membership',
    helpText: 'If you&rsquo;d like to update your&nbsp;member details, please&nbsp;call us on&nbsp;<a href="tel:1800 335 425">1800 335 425</a>.',
  },
  additionalInformationRebateDetails: {
    informationText: 'Rebate details were confirmed as a part of your quote.\r\n<p><u><a id="myCover">Change your rebate details</a>.</u></p>\r\n',
  },
  additionalInformationRebateSupportText: {
    informationText:
      '<p>A rebate is being applied based on details provided as a part of your quote. \u2028\u2028</p>\r\n\r\n<p><u><a id="myCover">Change your rebate details</a>. </u></p>\r\n',
  },
  additionalInformationUpdateVeteranDetails: {
    informationText: 'Veteran card details were provided as a part of your quote.\r\n<p><u><a id="myCover">Change your veteran card&nbsp;details</a></u></p>\r\n',
  },
  additionalInformationWithdrawRebate: {
    informationText:
      '<p>A rebate will not be applied based on details provided as a part of your quote.</p>\r\n\r\n<p><u><a id="myCover">Change your rebate details</a>.</u></p>\r\n',
  },
  additionalInformationRebate: {
    informationText:
      '<p>A rebate is being applied based on details provided as a part of your quote. \u2028\u2028</p>\r\n\r\n<p><u><a id="myCover">Change your rebate details</a>. </u></p>\r\n',
  },
  additionalInformationTransferringFundHistory: {
    informationText:
      '<p>Health insurance history details were provided as a part of your quote.</p>\r\n\r\n<p><u><a id="myCover">Change your health insurance history details</a>.</u></p>\r\n',
  },
  additionalInformationAddChildButtonLabel: {
    informationText: 'Add another child',
  },
  additionalInformationRebateHeading: {
    informationText: 'Add a rebate',
  },
  additionalInformationUpdateRebateHeading: {
    informationText: 'Update a rebate tier ',
  },
  additionalInformationUpdateRebateSupportText: {
    informationText: '<p>Your rebate tier is changing based on details provided as part of your quote.<br><br><a id="myCover">Change your rebate details.</a></p>\r\n',
  },
  additionalInformationCircumstanceTable: [
    {
      display: "It's just me",
      returnValue: 'single',
    },
    {
      display: 'I have kids and/or a partner',
      returnValue: 'other',
    },
  ],
  additionalInformationWithdrawRebateHeading: {
    informationText: 'Withdraw a rebate',
  },
  additionalInformationWithdrawRebateSupportText: {
    informationText: '<p>A rebate will not be applied based on details provided as part of your quote.<a id="rebates>Change your rebate details.</a></p>\r\n',
  },
  additionalInformationConfirmationHeading: {
    informationText: 'Your change of cover',
  },
  additionalInformationConfirmationInformationText: {
    informationText: '<p>You have nominated a Hospital excess of which is payable once per adult per financial year<p>',
  },
  additionalInformationConfirmationPremiumsInformationText: {
    informationText: '<p>Premiums will be adjusted from 1 April</p>',
  },
  additionalInformationConfirmationUserAcceptanceText: {
    informationText:
      '<p>I have read and understood the Privacy Policy.</p>\r\n\r\n<p>I have obtained the necessary consents from dependants over 16 years of age to disclose their personal information in this application form to Defence Health and give the same consents and authorisation I give in these declarations.</p>\r\n\r\n<p>I will make, or authorise the making of claims under this policy.</p>\r\n\r\n<p>If applicable I authorise my previous health funds to release to Defence Health all personal information concerning my dependants and me, which is required to confirm policy entitlements.</p>\r\n\r\n<p>I am aware that Defence Health hospital products are not suitable for non-residents without Medicare entitlements (including overseas visitors from countries with Australian Government reciprocal health care arrangements).</p>\r\n\r\n<p>I have read and understood the product information contained in this website including limitation of benefits for pre-existing condition and waiting periods.</p>\r\n',
  },
  changeMyCoverButtonLabel: {
    informationText: 'Change my cover',
  },
  confirmationSuccessHeading: {
    informationText: 'The cover has been updated',
  },
  confirmationSuccessSubtitle: {
    informationText:
      '<p>We&#39;ll send a new certificate of cover confirming the changes you&#39;ve made (including any new <a href="/portal/$memberNumber$/my-cover/My-waiting-periods">waiting periods</a>).</p>\r\n',
  },
  confirmationSuccessSubheading: {
    informationText: 'The cover has been updated',
  },
  confirmationSuccessPaymentHeading: {
    informationText: 'Your payment has been adjusted',
  },
  confirmationSuccessPaymentInformationText: {
    informationText: '<p>The requested changes have been applied to the membership.</p>\r\n\r\n<p>These will be confirmed in the certificate of cover</p>\r\n',
  },
  veteranCard: {
    label: 'I/My partner hold a Veterans Card',
    helpText: '<p>Holding a DVA Veteran Card may reduce your premiums</p>\r\n',
    options: [
      {
        display: 'Veteran Gold Card',
        returnValue: 'Veteran Gold Card',
      },
      {
        display: 'Veteran White Card',
        returnValue: 'Veteran White Card',
      },
    ],
  },
  discharge: {
    label: 'Was your date of discharge within the last 12 months?',
    helpText: '<p>Your eligibility determines whether you can receive a transition discount to reduce your premium.</p>\r\n',
  },
  veteranCardSelectionLabel: {
    informationText: 'Do you have a Veteran card?',
  },
  veteranCardWhiteTypeInformationText: {
    informationText: '<p>Additional details will need to be provided after you select a product.</p>\r\n',
  },
  veteranCardGoldTypeInformationText: {
    informationText: '<p>Private Health Insurance is not generally required in addition to a Veteran Gold Card.</p>\r\n',
  },
  currentlyReceivingABDHelpText: {
    informationText:
      '<p>If you are aged 18-25, you could save 10%&nbsp;on your premium every year that you remain on eligible cover with the age-based discount.</p>\r\n\r\n<p>The discount reduces by 2% annually if you take out eligible hospital cover for 26 to 29 year olds, and phases out by 2% each year after you turn 41.</p>\r\n',
  },
  firstReceiveAgeBasedDiscountOptions: {
    minimum: 18,
    maximum: 29,
    other: "I don't know",
  },
  currentlyReceivingABDWithAgeHelpText: {
    informationText: 'Your certified discount age may be updated when we receive the transfer certificate from your previous health fund.',
  },
  currentlyReceivingABDWithoutAgeHelpText: {
    informationText: 'We will apply a discount&nbsp; based on your age today. This may be updated when we receive the transfer certificate from your previous health fund.',
  },
  healthInsuranceFirstTimeHelpText: {
    informationText:
      '<p>Your certified discount age is the age you are when you take out private hospital insurance for the first time.</p>\r\n\r\n<p>We use this to apply an&nbsp;<a href="/error" target="_blank">age-based discount</a>&nbsp;on your premium.</p>\r\n',
  },
  currentlyReceivingABDNoHelpText: {
    informationText:
      '<p>Your certified discount age is the age you are when you take out private hospital insurance for the first time or after you&rsquo;ve had a break in cover.</p>\r\n\r\n<p>We use this to apply&nbsp;<a href="/error" target="_blank">an age-based-discount</a>on your premium.\r\n',
  },
  lhcOptions: [
    {
      display: 'An Australian citizen or permanent resident recently returned from overseas',
      returnValue: 'OSE',
      supportText: 'Recently returned from overseas means you returned within the past year for 90 days or more.',
    },
    {
      display: 'A new migrant to Australia',
      returnValue: 'IMM',
      supportText: 'New migrant means you have been registered for Medicare benefits within the last 12 months.',
    },
    {
      display: 'An ex-serving ADF member',
      returnValue: 'ADF',
      supportText: 'Ex-serving means you have previously served in Defence.',
    },
    {
      display: 'I have held hospital insurance continuously for last 10 years or since turning 31 years old',
      returnValue: 'YEA',
      supportText: 'Continuously holding hospital insurance means you have held hospital cover continuously without going above a total of 1094 days of absence.',
    },
    {
      display: 'I currently hold hospital cover.',
      returnValue: 'ERR',
      supportText: 'This means you have held hospital cover since turning 31 years old, until today.  This does not apply if you hold an extras only product.',
    },
    {
      display: 'None of the above',
      returnValue: 'NONE',
      supportText: 'This means a government mandated loading surcharge will be calculated for your premium, based on your age.',
    },
  ],
  lhcMigrantHelpText: {
    informationText: `<p>We use this to assess any Lifetime Health Cover loading that needs to be applied to the premium.</p>\r\n`,
  },
  firstReceivePHIAgeHelpText: {
    informationText:
      '<p>This is your certified age of entry (CAE) and determines the government mandated loading applied to your premium. Visit the Australian Government article on <a href="https://www.ato.gov.au/individuals-and-families/medicare-and-private-health-insurance/private-health-insurance-rebate/lifetime-health-cover">Lifetime Health Cover</a> for more information.</p>\r\n',
  },
  replacingPartnerHelpText: {
    informationText: '<p>Please provide the following details for the new partner on the policy.</p>\r\n',
  },
  appliedLoadingsInformationText: {
    informationText:
      '<p>Based on the information you provided, you may be subject to Lifetime Health Cover loading. To ensure we apply this correctly, please contact us at <a href="tel:1800335425">1800 335 425</a> to complete your requested change.</p>',
  },
};

export const terminationReasonFlexCodes = {
  terminationReasons: {
    policyReasons: [
      {
        code: 'UNFIN',
        description: 'Unfinancial',
      },
      {
        code: 'INV',
        description: 'Investigation',
      },
    ],
    memberReasons: [
      {
        code: 'DIS',
        description: 'Deceased in Service',
      },
      {
        code: 'AGE',
        description: 'Overage',
      },
    ],
    bothReasons: [
      {
        code: 'PMSCE',
        description: 'Poor member service/claims experience',
      },
      {
        code: 'CICO',
        description: 'Change in cover offered',
      },
      {
        code: 'AFF',
        description: 'Affordability',
      },
      {
        code: 'TCP',
        description: 'To another fund- Cheaper premium',
      },
      {
        code: 'TFR',
        description: 'Transfer to another DHL membership',
      },
      {
        code: 'ES',
        description: 'Employer Subsidised',
      },
      {
        code: 'PUB',
        description: 'Will use public system',
      },
      {
        code: 'RSN',
        description: 'Reason not enclosed',
      },
      {
        code: 'TBPO',
        description: 'To another fund-Better product options',
      },
      {
        code: 'TBB',
        description: 'To another fund- Better benefits',
      },
      {
        code: 'TLP',
        description: 'To another fund-Loyalty Program',
      },
      {
        code: 'TAF',
        description: 'To another fund',
      },
      {
        code: 'THEAL',
        description: 'To another fund- Health & wellbeing service',
      },
      {
        code: 'DEC',
        description: 'Deceased',
      },
      {
        code: 'ENL',
        description: 'Enlisted',
      },
      {
        code: 'VET',
        description: 'Veteran Affairs',
      },
      {
        code: 'PRC',
        description: 'Premium Cost',
      },
      {
        code: 'RFC',
        description: 'Relationship/Family change',
      },
      {
        code: 'NVRM',
        description: 'Not Value for Money',
      },
      {
        code: 'TBSER',
        description: 'To another fund- Better service/reputation',
      },
      {
        code: 'TPROM',
        description: 'To another fund-Promotional offer',
      },
    ],
  },
};

export const fundNames = {
  value: [
    {
      name: 'ACA Health Benefits Fund',
      dhl_code: 'ACA',
      dhl_hiccode: 'ACA',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'AHM',
      dhl_code: 'AHM',
      dhl_hiccode: 'AHM',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Australian Unity Health Ltd',
      dhl_code: 'AU',
      dhl_hiccode: 'AUF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'BUPA Health Insurance',
      dhl_code: 'Unk3',
      dhl_hiccode: 'BUP',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'CBHS Corporate Health Pty Ltd',
      dhl_code: 'CBC',
      dhl_hiccode: 'CBC',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'CBHS Health Fund Ltd',
      dhl_code: 'CBHS',
      dhl_hiccode: 'CBH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'CDH Benefits Fund',
      dhl_code: 'CDH',
      dhl_hiccode: 'CDH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'CUA Health Fund',
      dhl_code: 'CUA',
      dhl_hiccode: 'CPS',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Defence Health Ltd',
      dhl_code: 'AHBS',
      dhl_hiccode: 'AHB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Doctors Health Fund',
      dhl_code: 'AMA',
      dhl_hiccode: 'AMA',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Emergency Services Health',
      dhl_code: 'ESH',
      dhl_hiccode: 'SPE',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'GMHBA Health Fund',
      dhl_code: 'GMHBA',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Uni Health Insurance',
      dhl_code: 'UHI',
      dhl_hiccode: 'NTF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'HBF',
      dhl_code: 'HBF',
      dhl_hiccode: 'HBF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'HCF',
      dhl_code: 'HCF',
      dhl_hiccode: 'HCF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Health Care Insurance Ltd',
      dhl_code: 'HCI',
      dhl_hiccode: 'HCI',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'HIF',
      dhl_code: 'HIF',
      dhl_hiccode: 'HIF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Latrobe Health Services Inc',
      dhl_code: 'LHS',
      dhl_hiccode: 'LHS',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Medibank Private',
      dhl_code: 'MP',
      dhl_hiccode: 'MBP',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Mildura District Hospital Fund',
      dhl_code: 'MDHF',
      dhl_hiccode: 'MDH',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'One Medi Fund',
      dhl_code: 'OMF',
      dhl_hiccode: 'OMF',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Navy Health',
      dhl_code: 'NAVY',
      dhl_hiccode: 'NHB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'NIB Health Funds Ltd',
      dhl_code: 'NIB',
      dhl_hiccode: 'NIB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Nurses & Midwives Health',
      dhl_code: 'NMW',
      dhl_hiccode: 'NMW',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Peoplecare',
      dhl_code: 'LHMC',
      dhl_hiccode: 'LHM',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Phoenix Health Fund',
      dhl_code: 'PWAL',
      dhl_hiccode: 'PWA',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Police Health',
      dhl_code: 'SAPOL',
      dhl_hiccode: 'SPE',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Queensland Country Health Limited',
      dhl_code: 'QCH',
      dhl_hiccode: 'QCH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'R&T Health Fund',
      dhl_code: 'RTEFS',
      dhl_hiccode: 'RTE',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Reserve Bank Health Society',
      dhl_code: 'RBHS',
      dhl_hiccode: 'RBH',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: "St Luke's Health",
      dhl_code: 'SLMHB',
      dhl_hiccode: 'SLM',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Teachers Health',
      dhl_code: 'NSWTF',
      dhl_hiccode: 'NTF',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Transport Health',
      dhl_code: 'TFS',
      dhl_hiccode: 'TFS',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Queensland teachers union',
      dhl_code: 'QTUHS',
      dhl_hiccode: 'QTU',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Westfund',
      dhl_code: 'WDHF',
      dhl_hiccode: 'WFD',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'APIA',
      dhl_code: 'Unk9',
      dhl_hiccode: 'NIB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'GU Health Fund',
      dhl_code: 'GUC',
      dhl_hiccode: 'FAI',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Health Partners',
      dhl_code: 'HP',
      dhl_hiccode: 'SPS',
      dhl_istransfergatewayenabled: true,
    },
    {
      name: 'Frank Health Insurance',
      dhl_code: 'Unk1',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Fit Health Insurance',
      dhl_code: 'Unk2',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Central West Health Fund',
      dhl_code: 'Unk4',
      dhl_hiccode: 'HBF',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Health.com',
      dhl_code: 'Unk5',
      dhl_hiccode: 'HEA',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Budget Direct Health Insurance',
      dhl_code: 'Unk6',
      dhl_hiccode: 'GMH',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'RACQ Health Insurance',
      dhl_code: 'Unk7',
      dhl_hiccode: 'MYO',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'Qantas',
      dhl_code: 'Unk8',
      dhl_hiccode: 'NIB',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'AIA',
      dhl_code: 'AIA',
      dhl_hiccode: 'MYO',
      dhl_istransfergatewayenabled: false,
    },
    {
      name: 'GMF Health Fund',
      dhl_code: 'GMF',
      dhl_hiccode: 'GMF',
      dhl_istransfergatewayenabled: false,
    },
  ],
};
